import React from "react";
import _ from "underscore";
import { uuid } from "../../utils/lang";

export default class QuickStats extends React.Component {
    constructor(props) {
        super(props);
        this.uuid = uuid();
    }

    render() {
        const items = this.props.items ?? [];
        let className = "row stats-summary";

        if (this.props.className) {
            className += " " + this.props.className;
        }

        return (
            <div
                className={className}
            >
                {_.map(items, (item, index) => {
                    const {label, value} = item;
                    return (<div
                        key={"stats-summary-" + this.uuid + "-item-" + index}
                        className="col-sm-6 col-md"
                    >
                        <div
                            className="stats-summary__item"
                        >
                            <div
                                className="stats-summary__item-label"
                            >
                                {label}
                            </div>
                            <div
                                className="stats-summary__item-value"
                            >
                                {value}
                            </div>
                        </div>
                    </div>)
                })}
            </div>
        )
    }
}